export const string = {
  login: {
    signIn: "Sign In",
    heading: "Welcome",
    para: "Please sign in",
    email: "Email",
    password: "Password",
    rememberMe: "Remember me",
    otpHeading: "OTP Verification",
    otpPara: "Please Enter The 6 Digit Code Send to john@gmail.com",
    infoOtp: "Don't receive the OTP? ",
    resendOtp: "RESEND OTP",
    verify: "VERIFY & PROCEED",
  },
  welcome: {
    login: "Login",
    home: "Home",
    claimStatus: "Claim status",
    aboutUs: "About us",
    claims: "Claims",
    welcomePage: "Welcome page",
    heading: "Funeral Cover from Lorem Ipsum of the printing",
    paragraph:
      "Death comes unannounced; it is accompanied with heartbreak, financial constraints and a lot of stress.",
    deathClaim: "Death Claim",
    percentClaim: "10% Claim",
    whistleBlower: "Whistleblower",
    hotline: "Hotline",
    iSave: "iSave",
    payments: "Payments",
    phoneNumber: "086 000 7580",
    email: "info@icebolethu.co.za",
  },
  sidebar: {
    home: "Home",
    claims: "Claims Administration",
    ifas:"IFAS Administration",
    funeral:"Funeral Administration",
    tombstone:"Tombstone",
    tombstonePortal:"Tombstone Portal",
    memorials:"Memorials",
    memorialsPortal:"Memorials Portal",
    catering:"Catering",
    cateringPortal:"Catering Portal",
    fleetManagement:"Fleet Management",
    deathClaim: "Death Claim",
    percentClaim: "10% Claim",
    casePortal:"Case Portal",
    funeralPlanning:"Funeral Planning",
    funeralPortal:"Funeral Portal",
    specialServices:"Special Services",
    bodyRemoval:"Body Removal",
    mortuary:"Mortuary",
    warehouse:"Warehouse",
    bodyDispatch:"Body Dispatch",
    quotations:"Quotations",
    driver:"Driver",
    vehicle:"Vehicle",
    finance:"Finance",
    paymentProceed:"Payment",
    history:"History",
    cashPayout:"Cash Payout",
    servicePayout:"Service Payout",
    tenPercentPayout:"10% Payout"
  },
  searchbar: {
    newClaim: "New Claim",
  },
  claims: {
    policyInformation: "POLICY INFORMATION",
    policyNumber: "Policy number",
    chooseFile: "Choose File",
    noFileChosen: "No file chosen",
    next: "Next",
    back: "Back",
    submit: "Submit",
    rmaPolicyReport: "RMA Policy Report",
    claimantPersonalInformation: "CLAIMANT PERSONAL INFORMATION",
    detailsOfDeceased: "DETAILS OF DECEASED",
    bankingInformation: "BANKING INFORMATION",
  },
  warningPopup: {
    heading: " Warning!",
    para: "Claim not found. Please check and try again.",
    ok: "Ok",
  },
  otpPopup: {
    heading: "OTP Verification",
    para: "Please Enter The 6 Digit Code Send to your mobile number",
    infoOtp: "Don't receive the OTP? ",
    resendOtp: "RESEND OTP",
    verify: "VERIFY & PROCEED",
  },
  deceased: {
    titleOfInitials: "Title and Initials",
    firstName: "First name",
    lastName: "Last name",
    dob: "Date of birth",
    passportNumber: "Passport Number",
    identificationNumber: "Identification Number",
    relationshipToClaimant: "Relationship to claimant",
    fatherInLaw: "Father-in-law",
    motherInLaw: "Mother-in-law",
    sister: "Sister",
    brother: "Brother",
    husband: "Husband",
    wife: "Wife",
    child: "Child",
    spouse: "Spouse",
    causeOfDeath: "Cause of death",
    dod: "Date of Death",
    southAfricaId: "South Africa National ID",
    passport: "Passport",
    indentificationType: "Identification Type",
    IsItUnnatural: "Is it an un-natural death?",
    IsBodyRemoval:"Is body removal required?",
    deceasedId: "Deceased ID copy",
    bidhaForm1663: "BI/DHA 1663 Form",
    bidhaForm1680: "BI/DHA 1680 Form",
  },
  bankingInfo: {
    payableTo: "Payable to",
    relationship: "Relationship",
    nameOfAccountHolder: "Name of account holder",
    nameOfBank: "Name of bank",
    SBI: "State Bank Of India",
    CBI: " Central Bank of India",
    BOB: "Bank of Baroda",
    accountNumber: "Account number",
    branchName: "Branch Name",
    branchCode: "Branch code",
    accountType: "Account type",
    currentAcc: " Current Accounts",
    savingAcc: "Savings Accounts",
    fixedDepositAcc: "Fixed Deposit Accounts",
    idPassportNumber: "ID/Passport number",
    sourceOfFunds: "Source of funds/Income",
    occupation: "Occupation",
    email: "Email address",
    nationality: "Nationality",
    countryOfResidence: "Country of residence",
    countryOfBirth: "Country of Birth",
    termsAndConditions:
      "If the settlement of the benefit is being paid to a service provider please provide a bank statement not be older than three months or bank account confirmation letter.",
    signature: "Signature of Claimant",
    date: "Date",
    proofOfBanking: "Proof of Banking",
  },
  submission: {
    heading: "Form Submitted Successfully",
    para: "Your form has been submitted successfully! Processing is underway. Please wait while we complete the next steps.",
    home: "Home",
  },
  case:{
    heading: "Case Created Successfully",
    para: "Your case has been submitted successfully! Processing is underway. Please wait while we complete the next steps.",
    home: "Home",
  },
  quotation:{
    heading: "Quotation Created Successfully",
    para: "Your quotation has been submitted successfully! Processing is underway. Please wait while we complete the next steps.",
    home: "Home",
  },
  driver:{
    heading: "Driver Added Successfully",
    para: "Your driver's details has been submitted successfully! Processing is underway. Please wait while we complete the next steps.",
    home: "Home",
  },
  vehicle:{
    heading: "Vehicle Added Successfully",
    para: "Your vehicle's details has been submitted successfully! Processing is underway. Please wait while we complete the next steps.",
    home: "Home",
  }
};
